import React from "react";
import HeaderName from "./HeaderName";
import SideBar from "./SideBar";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div className="wrapper">
      <SideBar />
      <div className="overflow-auto" style={{ height: "100vh" }}>
        <HeaderName />
        <div className="content-wrapper overflow-y-auto pb-3">
          <Outlet />
        </div>
        <footer className="main-footer">
          <strong>
            Copyright &copy; 2017-2020{" "}
            <a href="http://www.kwintechnologies.com">K-win Technology</a>.
          </strong>
          All rights reserved.
        </footer>

        <aside className="control-sidebar control-sidebar-dark">
          {/* <!-- Control sidebar content goes here --> */}
        </aside>
      </div>
    </div>
  );
};

export default Layout;
